import { Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { IAddress } from '@bciti/types';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import * as uuid from 'uuid';
import { AddressSearchDialogComponent } from '../dialogs/address-search-dialog/address-search-dialog.component';

@Component({
    selector: 'app-address-card-input',
    templateUrl: './address-card-input.component.html',
    styleUrls: ['./address-card-input.component.scss'],
})
export class AddressCardInputComponent implements OnInit, OnDestroy, ControlValueAccessor {
    private destroy$ = new Subject();

    public onChange: (x?: any) => void;

    public onTouched: (x?: any) => void;

    public id: string;

    private _value: IAddress;

    @Input() disabled: boolean;
    @Input() label = '';
    @Input() placeholder: string = this.label;

    @Output() change = new EventEmitter<IAddress>();

    get value(): IAddress | undefined {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.onChange) {
            this.change.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    get formattedAddress(): string {
        if (!this._value) {
            return '';
        }
        return `${this._value.number} ${this._value.unit} ${this._value.street}, ${this._value.city}, ${this._value.province}, ${this._value.postCode}`;
    }

    get formattedCoordinates(): string {
        if (!this._value && !this._value?.latitude && !this._value?.longitude) {
            return '';
        }
        return `Latitude: ${this._value.latitude}. Longitude: ${this._value.longitude}.`;
    }

    constructor(private dialog: MatDialog, @Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();
    }

    openSearchAddressDialog(): void {
        this.dialog
            .open(AddressSearchDialogComponent)
            .afterClosed()
            .pipe(
                takeUntil(this.destroy$),
                tap((address?: IAddress) => {
                    if (address) {
                        this.value = address;
                    }
                }),
            )
            .subscribe();
    }

    writeValue(value: any): void {
        this._value = value;
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
